var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStamp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.47968 13.0813V14.1653C1.47968 14.4645 1.67581 14.7073 1.91746 14.7073H12.424C12.6657 14.7073 12.8618 14.4645 12.8618 14.1653V13.0813H1.47968Z",
    fill: "#f5f7fa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53826 5.31413C10.2525 4.58921 10.5554 3.60399 10.3689 2.61077C10.0995 1.17336 8.759 0.0732422 7.17074 0.0732422C5.56421 0.0732422 4.23828 1.19172 3.97254 2.61077C3.78609 3.60399 4.089 4.58921 4.80322 5.31413C5.28669 5.80511 5.46571 6.4332 5.53076 6.87354C5.66734 7.79954 5.37373 8.49929 5.00547 9.01633H9.33663C8.96806 8.49929 8.67444 7.79895 8.81072 6.87354C8.87576 6.4332 9.05478 5.80511 9.53826 5.31413Z",
    fill: "#f5f7fa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2415 12.2684H1.1006C0.861131 12.2684 0.666992 12.1124 0.666992 11.9199V11.5715C0.666992 10.6109 1.63957 9.82934 2.83501 9.82934H11.5071C12.7025 9.82934 13.6751 10.6109 13.6751 11.5715V11.9199C13.6751 12.1124 13.481 12.2684 13.2415 12.2684Z",
    fill: "#f5f7fa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStamp);
export default __webpack_public_path__ + "static/media/stamp.aa7a7f8a13ea12f6fbc4d2b84a94c52f.svg";
export { ForwardRef as ReactComponent };